import {uploadImage, uploadImageBase64, uploadImageSVG} from "./upload-image";
import {getDeviceType} from "../../library/device-type";
import Pickr from "@simonwep/pickr";
import {addToCartAjax} from "./add-to-cart-personalized";
import {ecSendData, trackEvent, sendFacebookConversionsEvent} from "../../library/analytics";
import {sendFloodLightEvent, showShoppingCart} from "./product-shopping-cart";
import {popupInfoDialog} from "../../library/info-dialog";
import {waitingDialog} from "../../library/waiting-dialog";
import {roundToMultiple} from "./add-to-cart-functions";
import {getDefaultFont, selectFont, unselectFont} from "./modal-font";
import {getPriceFormat} from "./price-format";
import {configureHelpWidget} from "./help-widget";

let canvas;
let elementId = 0;
let lastId = 0;
let bothFrontImages = false;

$(document).ready(function () {
    let productType = parseInt($("#product-type").val());
    bothFrontImages = productType === 9;

    loadCanvas();
    updatePrice(true);
    updatePreviewInformation();
    selectDefaultFont();
    displaySelectedCatalogProduct();
    updateMaterialColors($('input[name="clothing-model"]:checked').data('materialColorsShow'));

    setTimeout(function () {
        return new Promise(function(resolve, reject) {
            function waitUntilTawk() {
                setTimeout(function() {
                    if($('.widget-visible').length > 0){
                        setTimeout(function () {
                            $('.widget-visible').attr('style', 'z-index: 100 !important');
                        }, 100);
                    }else {
                        waitUntilTawk();
                    }
                }, 100);
            }
            //start the loop
            waitUntilTawk();
        });
    }, 200);

    if ($('.shape-element').length) {
        applyShapeToCanvas();
    }

    if (productType === 10) {
        updateSizesPriceByPack();
    }

    if (productType === 7) {
        changeTShirtImage();
        updatePreviewInformationTShirt();
    }

    $('.mockup-container').mousedown(function () {
        $('.mockup-layer').fadeOut();
    });

    window.addEventListener("keydown", function(event) {
        var e = event || window.event,
            target = e.target || e.srcElement;

        if (target.tagName.toUpperCase() === 'INPUT') {
            return;
        }

        const key = event.key; // const {key} = event; ES6+
        if (key === "Backspace" || key === "Delete") {
            e.preventDefault();
            removeCanvasActiveObject()
        }
    });

    $('body').on('click', '.composition', function (e) {
        let composition = $(this).val();
        let comp = $(this).data('composition');
        let numberOFCanvas = $(this).data('canvas');
        $('#preview-size').html(composition);
        $('#composition-measures').val(composition);
        $('#composition-canvas').val(numberOFCanvas);
        $('#composition').val(comp);
        if (getDeviceType() !== 'desktop') {
            $("#options-measure .close-options").click();
        }
        updatePrice();
    });

    $('.ps-menu-title').click(function() {
        let menu = $(this).parents('.ps-menu-item');
        if (getDeviceType() != 'desktop') {
            menu.siblings('.ps-menu-item').each(function(index, element) {
                closeMenu($(element));
            });
        }

        toggleMenu(menu);
    });

    $('body').on('click', '.open-ps-options', function (e) {
        if ($(this).hasClass('inactive')) {
            e.preventDefault();
            return;
        }
        let divName = $(this).data('options');
        let divOption = $("#"+divName);
        let id = divOption.attr("id");
        if (divOption.is(':visible')) {
            closeOptions(divOption);
            if (id == 'options-search') {
                $('.search-input-personalized').val('');
                $(".results-search").html('');
            }
            if (getDeviceType() !== 'desktop') {
                scrollToPosition($("#scroll-position").val());
            }
        } else {
            scrollTo('#product-image-container');
            showOptions(divOption, $(".ps-options"));
            if (id == 'options-search') {
                let sip = $('.search-input-personalized');
                sip.trigger('focus');
                sip.scrollTop(sip[0].scrollHeight);
            }
            if (getDeviceType() !== 'desktop') {
                $("#scroll-position").val($(window).scrollTop());
            }
        }
    });

    $(".close-submenu-options, .close-submenu").click(function() {
        let div = $(this).closest('.submenu-options, .submenu-element');
        changeDivVisibility(div);
        if (getDeviceType() !== 'desktop') {
            scrollToPosition($("#scroll-position").val());
        }
        if ($(this).hasClass('close-submenu')) $('.menu-element').removeClass('selected');
    });

    $(".close-menu").click(function() {
        let menu = $(this).closest('.ps-menu-item');
        closeMenu(menu);
    });

    let firstImage = true;
    $('#backgroundImage').change(function() {
        menuComplete($('#menu-add'));
        scrollTo('#product-image-container');
        let files = event.target.files;
        uploadImage(
            files,
            {prefix: 'personalized'},
            function(data) {
                if (data.done) {
                    let image = '/' + data.fileInfo.file;
                    let productType = parseInt($("#product-type").val());

                    if (firstImage && productType !== 7) {
                        if (productType === 6) {
                            setCanvasBackgroundImage(image);
                        } else if (productType === 3 || productType === 2) {
                            setCanvasBackgroundImageFullScreen(image, function() {
                                let background = getCanvasObjectById('background');
                                canvas.bringToFront(background);
                                //setObjectEditable(background);
                                $('#select-filter').show();
                                $('.inactive').removeClass('inactive');
                                $('#backgroundImage').val('');
                            });
                        } else if (productType === 12){
                            setCanvasBackgroundImageProportionalScale(image);
                        } else if (productType === 8 || productType === 10) {
                            setCanvasBackgroundImageProportionalScale(image, function() {
                                applyShapeToCanvas();
                                applyBorderShapeToCanvas();
                            });
                        } else if (productType === 9 || productType === 11) {
                            addDesignOnCanvas(image, 'mainDesign', function() {
                                $('#select-filter').show();
                                $('.inactive').removeClass('inactive');
                                $('#backgroundImage').val('');
                            });
                        }
                        firstImage = false;
                    } else {
                        addDesignOnCanvas(image);
                    }

                    $('.background-image .add-design-text').hide();
                    $('.background-image .add-designs-text').show();
                    $('.background-image i').removeClass('ps-upload').addClass('ps-add-image');
                    $('.radio-off.backgroundTypeImage').hide();
                    $('.radio-on.backgroundTypeImage').show();
                    $('.radio-off.backgroundTypeColor').show();
                    $('.radio-on.backgroundTypeColor').hide();
                    $('.upload-design-layer').fadeOut();
                    $("#btn-replace-background-image").show();
                }
            }
        );
    });

    $('#addImage').change(function() {
        scrollTo('#product-image-container');
        let files = event.target.files;
        uploadImage(
            files,
            {prefix: 'personalized'},
            function(data) {
                if (data.done) {
                    let image = '/' + data.fileInfo.file;
                    addDesignOnCanvas(image);
                }
            }
        );
    });

    $('#backgroundColor').click(function() {
        scrollTo('#product-image-container');
    });

    $('#textColor').click(function() {
        scrollTo('#product-image-container');
        $('.text-color-container').slideToggle();
    });

    $('.text-color-select').click(function() {
        $('.text-color-select').removeClass('text-color-selected');
        $(this).addClass('text-color-selected');
        let colorHex = $(this).data('hex');
        let activeObject = canvas.getActiveObject();
        let editObject = (activeObject && activeObject.text);
        $("#textColor").val(colorHex);
        if (editObject) {
            updateTextCanvas();
        }
        $('.text-color-container').slideUp();
    });

    /*let txtColorPicker = new Pickr({
        el: '#textColor',
        theme: 'classic',
        position: 'bottom-middle',
        useAsButton: true,
        components: {
            preview: true,
            opacity: false,
            hue: true,
            interaction: {
                save: true
            }
        },
        i18n: {
            'btn:save': 'OK'
        }
    });

    txtColorPicker.on('save', function(color, instance) {
        let colorHex = color.toHEXA().toString(3);
        let activeObject = canvas.getActiveObject();
        let editObject = (activeObject && activeObject.text);
        $("#textColor").val(colorHex);
        if (editObject) {
            updateTextCanvas();
        }
        instance.hide();
    });*/

    $('body').on('click', '.scrollTo', function () {
        let content = $(this).data('content');
        scrollTo(content);
    });

    $('.shape-element').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        let shape = $(this).data('value');
        let shapeName = $(this).data('name');
        let width = $(this).data('width');
        let height = $(this).data('height');
        setShape(shape, shapeName);
        $('#selectedShape').val($(this).attr('id'));
        applyShapeToCanvas();
        applyBorderShapeToCanvas();
        recalculateSizes();
        if (shape === 'CIRCLE') {
            $('.options-border-shape').hide();
        } else {
            $('.options-border-shape').show();
        }

        if (width && height) {
            $("#width").val(width);
            $("#height").val(height);
            updatePrice(true);
        }
    });

    $('body').on('click', '.effect-element', function () {
        let objectId;
        let productType = parseInt($("#product-type").val());

        if (productType === 11 || productType === 9) {
            objectId = 'mainDesign';
        } else {
            objectId = 'background';
        }

        let effect = $(this).data('value');
        if (effect !== $("#effect").val()) {
            adjustTextureSize(objectId);
            removeEffects(objectId);
            setEffect(effect, $(this).data('name'), objectId);
            canvas.renderAll();
        }
    });

    $('body').on('click', '.openModal', function () {
        let content = $(this).data('content');
        openModal(content);
    });

    $('#font-modal .select-font').first().addClass('selected-font');

    $('.select-font').click(function() {
        let selectedFont = $(this);
        let font = selectedFont.data('name');
        let fontFile = selectedFont.data('file');
        let rightToLeft = selectedFont.data('rtl');
        let activeObject = canvas.getActiveObject();
        let updateObject = (activeObject && activeObject.text);
        unselectFont();
        selectFont(font);
        $("#font").val(font);
        $("#font-file").val(fontFile);
        $("#font-rtl").val(rightToLeft);
        $('#font-modal').modal('hide');
        if (updateObject) {
            updateTextCanvas();
        }
    });

    $('body').on('change', '#personalized-text', function () {
        menuComplete($('#menu-add'));
        let activeObject = canvas.getActiveObject();
        let editObject = (activeObject && activeObject.text);
        if (editObject) {
            updateTextCanvas();
        } else {
            addTextToCanvas();
        }
    });

    $(".btn-add-to-cart").click(function(e) {
        e.preventDefault();
        saveCanvas();
    });

    $(".submenu-element").click(function(e) {
        if ($(this).hasClass('inactive')) {
            e.preventDefault();
            return;
        }
        $(".submenu-element").removeClass('selected');
        $(this).addClass('selected');
    });

    $('#select-filter').click(function() {
        let isDesktop = getDeviceType() == 'desktop';
        let filtersContainer = $('#filters-container');
        if (filtersContainer.is(':visible')) {
            if (isDesktop) {
                filtersContainer.slideUp();
            } else {
                filtersContainer.slideDownHide();
            }
        } else {
            if (isDesktop) {
                filtersContainer.slideDown();
            } else {
                filtersContainer.slideUpShow();
            }
        }
    });

    $(document).on('click', '.option-radio-calculator', function() {
        let radiobutton = $(this).closest('.product-option-radio').find('input[type="radio"]');
        radiobutton.prop('checked', true).trigger('change');
    });

    $(document).on('change', 'input[name="calculator"]', function() {
        let rollError = $('#wallpaper-calculator-error-rolls');

        if (rollError.is(':visible')) {
            rollError.slideUp();
        }
    });

    $(document).on('keyup', '.calculatorWidthPersonalized, .calculatorHeightPersonalized', function() {
        let wallWidth = $('#calculatorWidthPersonalized').val();
        let wallHeight = $('#calculatorHeightPersonalized').val();

        let errorSizes = $('#wallpaper-calculator-error-sizes');

        if (wallHeight && wallWidth) {
            if (errorSizes.is(':visible')) {
                errorSizes.slideUp();
            }
        }
    });

    $('#calculator').click(function() {
        let roll = $('input[name="calculator"]:checked');

        if (!roll.length) {
            let rollError = $('#wallpaper-calculator-error-rolls');

            if (!rollError.is(':visible')) {
                rollError.slideDown();
            }

            return;
        }

        let unit = roll.data('unit');
        let conversion = roll.data('conversion');
        let productWidth = roll.data('width');
        let productHeight = roll.data('height');

        let wallWidth = $('#calculatorWidthPersonalized').val();
        let wallHeight = $('#calculatorHeightPersonalized').val();

        let errorSizes = $('#wallpaper-calculator-error-sizes');
        if (!wallHeight || !wallWidth) {
            if (!errorSizes.is(':visible')) {
                errorSizes.slideDown();
            }

            return;
        }
        let calculatorResults = calculator(wallWidth, wallHeight, productWidth, productHeight, unit, conversion);
        let size = $("input[name='size']:checked");

        let composition = roll.data('composition');
        let device = roll.data('device');
        size.data('width', productWidth);
        size.data('height', productHeight);
        size.data('quantity', calculatorResults.rolls);

        size.data('composition', composition);
        size.data('device', device);

        let glueComplement = $('#complement-486');
        glueComplement.data('quantity', calculatorResults.glue);
        glueComplement.prop('checked', true).trigger('change');

        let quantitySelect =  $('input[name="quantity"][value="'+calculatorResults.rolls+'"]');
        quantitySelect.closest('li').addClass('selected');
        $('.quantity-preview').text(calculatorResults.rolls);
        quantitySelect.prop('checked', true).trigger('change');

        let calculatorOptions = $('#calculator-option');
        changeDivVisibility(calculatorOptions)
        let divResult = $('#calculator-result');
        let rollQuantity = $('.roll-quantity');
        let glueQuantity = $('.glue-complement-quantity');

        rollQuantity.text(calculatorResults.rolls);
        glueQuantity.text(calculatorResults.glue);

        changeDivVisibility(divResult);
    });

    $('.back-calculator').click(function() {
        let calculatorOptions = $('#calculator-option');
        let divResult = $('#calculator-result');
        changeDivVisibility(divResult)
        $('#calculatorWidthPersonalized').val('');
        $('#calculatorHeightPersonalized').val('');
        changeDivVisibility(calculatorOptions)

        let glueComplement = $('#complement-486');
        glueComplement.data('quantity', 1);
        glueComplement.prop('checked', false).trigger('change');
    });

    $('#widthPersonalized').change(function() {
        let width = parseInt($(this).val());
        let shape = $('#shape').val();
        let productType = parseInt($("#product-type").val());

        width = isNaN(width) ? 0 : width;

        if (!canvas) {
            return;
        }

        if (shape === 'RECTANGLE') {
            updateRectangleBySizes();
        } else if (productType !== 3 && productType !== 12) {
            let height = getProportionalSize(canvas.getWidth(), width, canvas.getHeight());
            height = isNaN(height) ? 0 : height;
            $('#heightPersonalized, #height').val(height).removeClass('empty');
        }
        $("#width").val(width);
        updatePrice(true);

        if (productType === 12) {
            let maxWidth = getPercentValue(73, $("#product-image-container").width());
            let maxHeight = $("#product-image-container").height() - 30;
            recalculateProportionalCanvasSize(parseFloat($("#width").val()), parseFloat($("#height").val()), maxWidth, maxHeight);
            let image = getCanvasObjectById('background');
            if (image) {
                rescaleImage(image);
            }
        }

        let height = parseInt($("#height").val());
        height = isNaN(height) ? 0 : height;
        if (width && height) {
            menuComplete($("#menu-measure"));
        } else {
            menuIncomplete($("#menu-measure"));
        }
    });

    $('#heightPersonalized').change(function() {
        let height = parseInt($(this).val());
        let shape = $('#shape').val();
        let productType = parseInt($("#product-type").val());

        if (!canvas) {
            return;
        }

        if (shape == 'RECTANGLE') {
            updateRectangleBySizes();
        } else if (productType !== 3 && productType !== 12) {
            let width = getProportionalSize(canvas.getHeight(), height, canvas.getWidth());
            $('#widthPersonalized, #width').val(width).removeClass('empty');
        }
        $("#height").val(height);
        updatePrice(true);

        if (productType === 12) {
            let maxWidth = getPercentValue(73, $("#product-image-container").width());
            let maxHeight = $("#product-image-container").height() - 30;
            recalculateProportionalCanvasSize(parseFloat($("#width").val()), parseFloat($("#height").val()), maxWidth, maxHeight);
            let image = getCanvasObjectById('background');
            if (image) {
                rescaleImage(image);
            }
        }

        let width = parseInt($("#width").val());
        if (width && height) {
            menuComplete($("#menu-measure"));
        } else {
            menuIncomplete($("#menu-measure"));
        }
    });

    $(document).on("change", ".qty-display", function () {
        if (isNaN(parseInt($(this).val())) || parseInt($(this).val()) < 1 || $(this).val() === '') {
            $(this).val('1');
        }
        updatePrice();
    });

    $(document).on('click', '#summaryButton', function () {
        createSummary();
    });

    $(document).on('blur', '#widthPersonalized', function() {
        let multiple = $(this).data('multiple');
        if (multiple) {
            checkIncorrectSizes();
            roundToMultiple(multiple, $(this));
        }
    });

    $(document).on('blur', '#heightPersonalized', function() {
        let multiple = $(this).data('multiple');
        if (multiple) {
            checkIncorrectSizes();
            roundToMultiple(multiple, $(this));
        }
    });

    $(document).on('click', '.btn-edit-canvas, .btn-preview-canvas', function() {
        let mode = $(this).data('mode');
        $('#mode').val(mode);
        changeCanvasViewByMode();
    });

    $(document).on('click', function (e) {
        let disabledTargets = `
            .mockup-container,
            .mockup-container *,
            .btn-edit-canvas,
            .btn-edit-canvas *,
            .btn-preview-canvas,
            .btn-preview-canvas *,
            #options-measure,
            #options-measure *,
            #options-caracteristics,
            #options-add-text *,
            #font-modal *,
            .pcr-app *,
            #div-add-text *
        `;

        if (!$(e.target).is(disabledTargets)) {
            let mode = $("#mode").val();
            if (mode !== 'preview') {
                $('#mode').val('preview');
                changeCanvasViewByMode();
            }
        }

        if ($(e.target).is('.mockup-container *')) {
            let mode = $("#mode").val();
            if (mode !== 'edit') {
                $('#mode').val('edit');
                changeCanvasViewByMode();
            }
        }
    });

    $(document).on('click', '.option-radio', function() {
        let radiobutton = $(this).closest('.product-option-radio').find('input[type="radio"]');
        let productType = parseInt($("#product-type").val());

        if (productType === 2) {
            collapseWallpaperCalculator();
        }

        radiobutton.prop('checked', true).trigger('change');
    });

    $(document).on('click', '.wallpaper-calculator-toggle', function() {
        let toggle = $(this);

        if (toggle.attr('aria-expanded') === 'true') {
            collapseWallpaperCalculator();
            $('input[name="size"]').not('.wallpaper-calculator-size').first().prop('checked', true).trigger('change');

            return;
        }

        toggle.attr('aria-expanded', 'true').closest('.wallpaper-calculator-box').addClass('expanded');
        $('.options-calculator').slideDown();
        $('.wallpaper-calculator-size').prop('checked', true).trigger('change');
    });

    $('.material').change(function () {
        let product = $(this).data('product');
        let color = $(this).data('color');
        let trim = $(this).data('trim');
        $("#productId").val(product);
        $("#color").val(color);
        $("#trim").val(trim);
        updatePrice(true);

        $('.complement-item, .cross-selling-item').hide();
        $(`.complement-item[data-product-parent='${product}']`).show();
        $(`.cross-selling-product[data-original-product='${product}']`).closest('.cross-selling-item').show();
        menuComplete($("#menu-material"));
    });

    $('.change-visualization-mode-images').change(function() {
        let background = $(this).data('background');
        let front = $(this).data('front');
        $("#background").data('originalUrl', background);
        $("#front").data('originalUrl', front);
        changeVisualizationModeImages(background, front);
    });

    $(document).on('change click', '.update-price', function() {
        updatePrice();
    });

    $('.update-preview-information').on('change click', function() {
        let element = $(this).data('previewElement');
        let content = $(this).data('previewContent');
        updatePreviewInformation(element, content);
    });

    $('input[name="border-shape"]').change(function() {
        let productType = parseInt($("#product-type").val());
        if (productType === 9) {
            $("#visualization-images-end-prefix").val($(this).data('prefix'));
            let background = $("#background").data('originalUrl');
            let front = $("#front").data('originalUrl');
            changeVisualizationModeImages(background, front);
        } else {
            applyBorderShapeToCanvas();
        }
    });

    $('#customPack').focus(function() {
        $("#pack-custom").prop("checked", true);
        if ($(this).val() !== '') {
            $("#pack").val($(this).val());
            updatePrice(true);
        }
    });

    $('input[name="pack"], #customPack').change(function() {
        let currentElement = $(this);
        let pack = currentElement.val();

        if (currentElement.attr('id') === 'pack-custom') {
            pack = currentElement.closest('.product-custom-pack').find('#customPack').val();
        }

        $("#pack").val(pack);
        if (validatePacks()) {
            return;
        }
        updatePrice(true);
        if ($("input[name='size']").length) {
            updateSizesPriceByPack();
        }
    });

    $('input[name="clothing-model"]').change(function() {
        let model = parseInt($(this).val());
        $("#clothing-model").val(model);
        let materialColorsToShow = $(this).data('materialColorsShow');
        updateMaterialColors(materialColorsToShow);
        $('.material-color-select:visible:first').click();
        changeTShirtImage();
        updatePreviewInformationTShirt();
        updatePrice(true);
    });

    $('.change-elements-visibility').change(function() {
        let elementToHide = $(this).data('elementToHide');
        let elementToShow = $(this).data('elementToShow');
        changeElementsVisualization(elementToHide, elementToShow);
    });

    $('.material-color-select').click(function () {
        selectMaterialColor($(this));
        changeTShirtImage();
    });

    $('.update-clothing-sizes').change(function() {
        updateClothingSizes(function() {
            $('input[name="clothing-size"]:checked').change();
        });
    });

    $(document).on('click', '#show-clothing-sizes-info', function() {
        let type = 'modelSize';
        let productId = $('#productId').val();
        let model = $("#clothing-model").val();
        showInfoDialog(type, productId, model);
    });

    $(document).on('change', 'input[name="clothing-size"]', function() {
        let clothingSize = $(this).val();
        $("#clothing-size").val(clothingSize);
        updatePreviewInformationTShirt();
    });

    $('body').on('change', '.change-value-specific-input', function(e) {
        let input = $(this).data('input');
        let value = $(this).data('value');
        $(input).val(value);
        if ($(this).hasClass('update-price')) {
            updatePrice();
        }
    });

    $('body').on('change', 'input[name="mechanism"], input[name="chainPosition"]', function(e) {
        $('.mechanism-option .short-label').removeClass('checked');
        $(this).next('.short-label').addClass('checked');
        let body = $(this).closest('.mechanism-option').find('.mechanism-body');
        $('.mechanism-body').not(body).slideUp(function() {
            body.slideDown();
        });
        $(".save-mechanism").show();
    });

    $('body').on('change', 'input[name="tissue"]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(".save-blind-tissue-option").show();
        updatePrice(true);
    });

    $('body').on('change', 'input[name="drop"]', function(e) {
        $(".save-blind-drop-option").show();
    });

    $('.qty-btn').click(function() {
        let input = $(this).data('input');
        let action = $(this).data('action');
        let quantity = parseInt($(input).val());

        if (action === 'add') {
            quantity += 1;
        } else if (action === 'remove') {
            quantity = quantity > 0 ? quantity - 1 : 0;
        }
        $(input).val(quantity);
    });

    $('.save-mechanism').click(function() {
        let row = $('input[name="mechanism"]:checked').closest('.mechanism-option');
        let mechanism = row.find('input[name="mechanism"]').val();
        let mechanismName = row.find('.mechanism-name').text();
        let chainPosition = row.find('input[name="chainPosition"]:checked').val();
        let controlData = [];
        let control = row.find('input[name="control"]');
        let chargerData = [];
        let charger = row.find('input[name="charger"]');

        if (control.length) {
            controlData = {
                id: control.data('id'),
                locked: control.data('locked'),
                linkToParent: control.data('link-to-parent'),
                price: control.data('price'),
                quantity: control.val(),
                width: control.data('width'),
                height: control.data('height'),
                device: control.data('device'),
                composition: control.data('composition')
            };
        }

        if (charger.length) {
            chargerData = {
                id: charger.data('id'),
                locked: charger.data('locked'),
                linkToParent: charger.data('link-to-parent'),
                price: charger.data('price'),
                quantity: charger.val(),
                width: charger.data('width'),
                height: charger.data('height'),
                device: charger.data('device'),
                composition: charger.data('composition')
            };
        }

        $("#mechanism").val(mechanism);
        $("#control-data").val(JSON.stringify(controlData));
        $("#charger-data").val(JSON.stringify(chargerData));
        $("#chain-position").val(chainPosition);
        updatePrice(true);
        $("#preview-mechanism").text(mechanismName.split('(')[0]);
        $("#modal-mechanisms").modal('hide');
    });

    $('body').on('click', '.open-item-options', function (e) {
        let divId = $(this).data('div');
        let div = $(`#${divId}`);
        if (div.is(':visible')) {
            closeOptions(div);
        } else {
            showOptions(div, $(".item-options"));
        }
    });

    $(document).on('click', '.image-option-radio', function() {
        let radiobutton = $(this).find('input[type="radio"]');
        radiobutton.prop('checked', true).trigger('change');
    });

    $(document).on('click', '.cross-selling-item', function() {
        let input = $(this).find('input');
        if (input.is(':checked')) {
            input.prop('checked', false).trigger('change');
        } else {
            input.prop('checked', true).trigger('change');
        }
    });

    $('#open-wallpaper-pattern-info').click(function() {
        $("#modal-wallpaper-pattern-info").modal();
    });

    $('.sticker-color-select').click(function() {
        $('.sticker-color-select').removeClass('color-selected');
        $(this).addClass('color-selected');
        displaySelectedCatalogProduct();
        $('.upload-design-layer').fadeOut();
        $('.submenu-element[data-options="options-backgroundColor"]').click();
        menuComplete($('#menu-add'))
    });

    $('body').on('click', '.change-div-visibility', function (e) {
        if ($(this).hasClass('inactive')) {
            return;
        }
        let divToShow = $(this).data('divToShow');
        let divToShowElement = $(divToShow);
        let divToHide = $(this).data('divToHide');
        let hasOtherElementsShown = $(divToHide+':visible').not(divToShowElement).length;
        if (hasOtherElementsShown) {
            $(divToHide).not(divToShowElement).slideUp();
            setTimeout(
                function () {
                    changeDivVisibility(divToShowElement);
                },
                400
            );
        } else {
            changeDivVisibility(divToShowElement);
        }

    });

    $('.menu-element').click(function() {
        let isSelected = $(this).hasClass('selected');
        $('.menu-element').removeClass('selected');
        if (!isSelected) $(this).addClass('selected');
        if ($(this).hasClass('force-completed')) menuComplete($(this));
    });

    $('.upload-design-layer').click(function() {
        $('.widget-visible iframe').css({'bottom': '282px'});
        let backgroundImage = $('label[for="backgroundImage"]');
        let addImage = $('label[for="addImage"]');
        if (backgroundImage.length) {
            backgroundImage.click();
        } else if (addImage.length) {
            addImage.click();
        } else if ($('#backgroundImage').length) {
            $("#backgroundImage").click();
        }
    });

    $('#modal-tissues, #modal-mechanisms, #modal-fabric-drops').on('hide.bs.modal', function (e) {
        let tissue = $("#tissue").val();
        let mechanism = $("#mechanism").val();
        let drop = $("#fabric-drop").val();
        if (tissue !== '' && mechanism !== '' && drop !== '') {
            menuComplete($('#menu-features'));
        }
    });

    $(document).on('click', '.quantity-selector li', function() {
        let container = $(this).closest('.quantity-selector');
        let preview = container.find('.quantity-preview');
        let input = $(this).find('input');
        let quantity = input.val();

        container.find('li').removeClass('selected');
        $(this).addClass('selected');
        input.prop('checked', true);
        input.change();
        preview.text(quantity);
    });

    $('input[name="size"]').change(function(e) {
         e.preventDefault();
         e.stopPropagation();
         updatePrice(true);
    });

    $("#btn-replace-background-image").click(function() {
        firstImage = true;
        $("#backgroundImage").click();
    });

    /*onElementInserted('body', '.widget-visible', function(element) {
        console.log(element);
        element.css({'z-index': '700 !important'});
    });*/

    configureHelpWidget();

    if (getDeviceType() !== 'desktop') $("#dropdownQuantitySelector").closest('.quantity-selector').removeClass('dropdown').addClass('dropup');
});

/*function onElementInserted(containerSelector, elementSelector, callback)
{
    var onMutationsObserved = function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                var elements = $(mutation.addedNodes).find(elementSelector);
                for (var i = 0, len = elements.length; i < len; i++) {
                    callback(elements[i]);
                }
            }
        });
    };

    var target = $(containerSelector)[0];
    var config = { childList: true, subtree: true };
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(onMutationsObserved);
    observer.observe(target, config);
}*/

function calculator(wallWidth, wallHeight, productWidth, productHeight, unit, conversion)
{
    let rolls = getRollQuantity(wallWidth, wallHeight, productWidth, productHeight, unit, conversion);
    let glue = getGlueQuantity(rolls, productHeight);


    return {'rolls': rolls, 'glue': glue};
}

function getRollQuantity(wallWidth, wallHeight, productWidth, productHeight, unit, conversionFactor)
{
    unit = unit || 'cm';
    conversionFactor = Number(conversionFactor) || 1;

    if (unit === 'in') {
        wallWidth = Number(wallWidth) * conversionFactor;
        wallWidth = Math.floor(wallWidth.toFixed(2));
        wallHeight = Number(wallHeight) * Number(conversionFactor);
        wallHeight = wallHeight.toFixed(2);
    }

    var width = Number(wallWidth) / Number(productWidth);
    var height = Number(wallHeight) / Number(productHeight);

    if (Number(productHeight) < 1000) {
        height = Math.ceil(height);
    }

    return Math.ceil(width * height);
}

function getGlueQuantity(numberOfRolls, productHeight) {
    var rollPerGlue = 16;

    switch (productHeight) {
        case '1000':
            rollPerGlue = 4;
            break;
        case '300':
            rollPerGlue = 16;
            break;
    }

    return Math.ceil(Number(numberOfRolls) / rollPerGlue);
}

function changeDivVisibility(div)
{
    if (div.is(":visible")) {
        div.slideUp();
    } else {
        div.slideDown();
    }
}

function setEffect(effect, effectName, objectId) {
    $(".effect-element").removeClass('selected');
    $('.effect-element[data-value="'+effect+'"]').addClass('selected');
    $("#effect").val(effect);
    $("#effect-name").val(effectName);
    switch (effect) {
        case 'SEPIA':
            applyEffectSepia(objectId);
            break;
        case 'GRAYSCALE':
            applyEffectGrayScale(objectId);
            break;
        case 'ORIGINAL':
            $("#effect-name").val('-');
            break;
    }
}

function applyEffectSepia(objectId) {
    removeEffects(objectId);
    let object = getCanvasObjectById(objectId);
    let filter = new fabric.Image.filters.Sepia();
    if (object) {
        object.filters.push(filter);
        object.applyFilters();
    }
}

function applyEffectGrayScale(objectId) {
    removeEffects(objectId);
    let object = getCanvasObjectById(objectId);
    let filter = new fabric.Image.filters.Grayscale();
    if (object) {
        object.filters.push(filter);
        object.applyFilters();
    }
}

function removeEffects(objectId) {
    let object = getCanvasObjectById(objectId);
    if (object) {
        object.filters = [];
        object.applyFilters();
    }
}

function toggleMenu(menu) {
    let subMenu = menu.find('.ps-submenu');
    if (subMenu.is(':visible')) {
        closeMenu(menu);
    } else {
        openMenu(menu);
    }
}

function closeMenu(menu) {
    let subMenu = menu.find('.ps-submenu');
    let arrow = menu.find('.ps-menu-arrow');
    let isDesktop = getDeviceType() == 'desktop';

    menu.removeClass('selected');
    if (isDesktop) {
        subMenu.slideUp();
    } else {
        subMenu.slideDownHide();
    }
    arrow.removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
}

function openMenu(menu) {
    let subMenu = menu.find('.ps-submenu');
    let arrow = menu.find('.ps-menu-arrow');
    let isDesktop = getDeviceType() == 'desktop';

    menu.addClass('selected');
    if (isDesktop) {
        subMenu.slideDown();
    } else {
        subMenu.slideUpShow();
    }
    arrow.removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
}

export function closeOptions(div) {
    $(".submenu-element").removeClass('selected');
    if (getDeviceType() == 'desktop') {
        div.slideUp();
    } else {
        div.slideDownHide();
    }
}

function showOptions(div, elements) {
    if (getDeviceType() == 'desktop') {
        if (elements.is(':visible')) {
            elements.slideUp();
            setTimeout(
                function(){
                    div.slideDown();
                },
                500
            );
        } else {
            div.slideDown();
        }
    } else {
        elements.hide();
        div.slideUpShow();
    }
}

function scrollTo(id) {
    let breadcrumbStart = $('#breadcrumbDiv').offset().top;
    $('html, body').animate({ scrollTop: $(id).offset().top - breadcrumbStart}, 1000);
}

function openModal(id)
{
    $(id).modal();
}

function loadCanvas()
{
    let container = $("#product-image-container");
    let size = container.width();
    container.height(size);
    canvas = new fabric.Canvas("product-image", {
        preserveObjectStacking: true
    });
    canvas.setDimensions({width: size, height: size});
    if (!$("#btn-replace-background-image").length) renderDeleteButton();
    canvas.on('mouse:down', function(options) {
        let element = options.target;
        if (element) {
            if (element.text) {
                canvas.setActiveObject(element);
                $("#personalized-text").val(element.text);
                $('.text-color-select').each(function() {
                    let colorElement = $(this);
                    if (colorElement.data('hex') === element.textData.color) {
                        $('.text-color-selected').removeClass('text-color-selected');
                        colorElement.addClass('text-color-selected');
                        $("#textColor").val(element.textData.color);
                    }
                });
                $('.select-font').each(function() {
                    let fontElement = $(this);
                    let font = fontElement.data('name');
                    let fontFile = fontElement.data('file');
                    let rightToLeft = fontElement.data('rtl');
                    if (font === element.textData.font) {
                        unselectFont();
                        selectFont(element.textData.font);
                        $("#font").val(font);
                        $("#font-file").val(fontFile);
                        $("#font-rtl").val(rightToLeft);
                    }
                });

                if (!$("#options-add-text").is(":visible")) {
                    $(".open-ps-options[id='addText']").click();
                }
            } else {
                $("#personalized-text").val('');
            }
        }
    });

    let productType = parseInt($("#product-type").val());
    if (productType === 11) {
        let input = $("input[name='composition']:checked");
        let background = input.data('background');
        let front = input.data('front');
        changeVisualizationModeImages(background, front);
    } else if (productType === 9) {
        let input = $("input[name='size']:checked");
        let background = input.data('background');
        let front = input.data('front');
        $("#background").data('originalUrl', background);
        $("#front").data('originalUrl', front);
        changeVisualizationModeImages(background, front);
    } else if (productType === 7) {
        let width = getPercentValue(55, canvas.width);
        let height = getPercentValue(72, canvas.height);
        updateCanvasSizes(width, height);
        marginTopCanvasByPercent(getPercentValue(25, canvas.height));
        centerCanvasHorizontally();
        $('.canvas-container canvas').addClass('canvas-bordered');
    } else if (productType === 12) {
        let width = getPercentValue(73, canvas.width);
        let height = getPercentValue(85, canvas.width);
        updateCanvasSizes(width, height);
        marginTopCanvasByPercent(getPercentValue(3.6, canvas.height));
        centerCanvasHorizontally();
        $('.canvas-container canvas').addClass('canvas-bordered');
    }

    canvas.on('selection:created', function () {
        if (productType !== 6) {
            $('#mode').val('edit');
            changeCanvasViewByMode();
        }
    });

    canvas.on('object:removed', function(options) {
        let element = options.target;
        if ((element.id === 'background' && productType !== 9 && productType !== 11) || (element.id === 'mainDesign')) {
            $('#select-filter, #div-filters').hide();
            setEffect('ORIGINAL', $('#effect-original').data('name'));

            if (productType === 6) {
                setShape('ORIGINAL', $('#shape-original').data('name'));
                showOriginalShapeOption();
                applyShapeToCanvas();
            }
        }
    });
}

function setCanvasBackgroundImage(image, callback) {
    removeCanvasObject('background');
    canvas.clipPath = null;
    showOriginalShapeOption();

    let selectedShape = '';
    if ($('#selectedShape').val()) {
        selectedShape = $('#selectedShape').val();
    }

    let shape = 'ORIGINAL';
    if (selectedShape.length && $('#'+selectedShape).data('value') !== 'RECTANGLE') {
        setShape($('#'+selectedShape).data('value'), $('#'+selectedShape).data('name'));
        setEffect('ORIGINAL', $('#effect-original').data('name'));
        shape = $('#'+selectedShape).data('value');
    } else {
        setShape('ORIGINAL', $('#shape-original').data('name'));
        setEffect('ORIGINAL', $('#effect-original').data('name'));
    }
    let containerSize = $('#product-image-container').height();
    lastId = 'background';
    fabric.Image.fromURL(image, function (img) {
        let scaleWidth = containerSize;
        let scaleHeight = 0;
        if (img.height > img.width) {
            scaleWidth = 0;
            scaleHeight = containerSize;
        }
        img.set({
            id: 'background',
            lockMovementY: false,
            lockMovementX: false,
            hasControls: true,
            hasBorders: true,
            borderColor: '#000',
            cornerColor: '#000',
            selectable: true,
            hoverCursor: 'default',
            transparentCorners: false
        });
        if (scaleWidth) {
            img.scaleToWidth(scaleWidth);
        } else if (scaleHeight) {
            img.scaleToHeight(scaleHeight);
        }
        canvas.add(img);
        canvas.bringToFront(img);
        canvas.setWidth(img.width * img.scaleX);
        canvas.setHeight(img.height * img.scaleY);
        getCanvasObjectById('backgroundColor').width = canvas.width;
        getCanvasObjectById('backgroundColor').height = canvas.height;
        canvas.setActiveObject(img);
        centerCanvas();
        $("#shape").val(shape);
        $('#select-filter').show();
        $('.inactive').removeClass('inactive');
        resetSizes();
        applyShapeToCanvas();
        applyBorderShapeToCanvas();
        recalculateSizes();

        if (callback) {
            callback();
        }
    });
}

export function addDesignOnCanvas(image, id, callback) {
    if (!id) {
        id = 'design'+(++elementId);
        lastId = id;
    }
    fabric.Image.fromURL(image, function (img) {
        img.set({
            id: id,
            top: canvas.height / 2,
            left: canvas.width / 2,
            originX: 'center',
            originY: 'center',
            lockMovementY: false,
            lockMovementX: false,
            hasControls: true,
            hasBorders: true,
            selectable: true,
            borderColor: '#000',
            cornerColor: '#000',
            hoverCursor: 'pointer',
            transparentCorners: false
        });
        if (img.width > (canvas.width - 25)) {
            let newWidth = canvas.width - 25;
            let newHeight = getProportionalSize(img.width, newWidth, img.height);
            while (newHeight > canvas.height) {
                newWidth = newWidth - 10;
                newHeight = getProportionalSize(img.width, newWidth, img.height);
            }
            img.scaleToWidth(newWidth);
        } else if(img.height > (canvas.height - 25)) {
            let newHeight = canvas.height - 25;
            let newWidth = getProportionalSize(img.height, newHeight, img.width);
            while (newWidth > canvas.width) {
                newHeight = newHeight - 10;
                newWidth = getProportionalSize(img.height, newHeight, img.width);
            }
            img.scaleToHeight(newHeight);
        }
        canvas.add(img);
        canvas.setActiveObject(img);
        if (callback) {
            callback(img);
        }
    }, null,{
        crossOrigin: 'Anonymous',
        userImage: image
    });
}

function removeCanvasObject(id)
{
    let object = getCanvasObjectById(id);
    if (object) {
        canvas.remove(object);
    }
}

function getCanvasObjectById(id)
{
    let object = null;
    let objects = canvas.getObjects();
    objects.forEach(function (currentObject) {
        if (currentObject.id && currentObject.id === id) {
            object = currentObject;
        }
    });

    return object;
}

function addTextToCanvas()
{
    renderTextImage(function(image, textData) {
        addSvgToCanvas(image, textData, false);
        $('.upload-design-layer').fadeOut();
    });
}

function updateTextCanvas()
{
    renderTextImage(function(image, textData) {
        addSvgToCanvas(image, textData, true);
    });
}

function renderTextImage(callback)
{
    let text = $("#personalized-text").val();
    let font = $("#font").val();
    let fontFile = $("#font-file").val();
    let rightToLeft = $("#font-rtl").val();
    let color = $("#textColor").val() || '#000000';
    let textData = {
        text: text,
        font: font,
        fontFile: fontFile,
        rightToLeft: rightToLeft,
        color: color,
    };
    $.post(
        '/ajax/personalized-services/render-text',
        textData,
        function(data){
            if (data.done) {
                callback(data.svg, textData);
            } else {
                if (data.errorMessage) {
                    popupInfoDialog(data.errorMessage, false, true);
                }
                callback(null);
            }
        }
    );
}

function saveCanvas()
{
    let productType = parseInt($("#product-type").val());

    fabric.Image.prototype.getSvgSrc = function() {
        return this.toDataURL();
    }

    let designElements = {
        backgroundColor: $('#background-color').val() || null,
        texts: [],
        images: []
    };
    let objects = canvas.getObjects();
    objects.forEach(function (currentObject) {
        if (currentObject.text) {
            designElements.texts.push(currentObject.textData);
        } else if (currentObject._element && currentObject._element.currentSrc) {
            if (currentObject._element.currentSrc.indexOf("/canvas/") === -1) {
                designElements.images.push(currentObject._element.currentSrc);
            }
        }
    });
    $('#design-elements').val(JSON.stringify(designElements));

    if (productType === 2 && !designElements.images.length) {
        failureAddToCart({errorMessage: $('#personalized-image-empty-alert').text().trim()});
        return;
    }

    if (productType === 11 || productType === 9) {
        $("#mode").val('preview');
        waitingDialog.show();
        viewPreviewMode(function() {
            let imgBase64 = canvas.toDataURL({
                format: 'png'
            });

            viewEditMode(function() {
                removeCanvasObject('background');
                removeOpacityAllCanvasObjects();
                canvas.renderAll();
                let imgSVG = canvas.toSVG({ suppressPreamble: true });
                uploadCanvasImages(imgSVG, imgBase64, function() {
                    viewPreviewMode();
                    canvas.renderAll();
                });
            });
        });
    } else {
        let imgSVG = canvas.toSVG({ suppressPreamble: true });
        let imgBase64 = canvas.toDataURL({
            format: 'png'
        });
        uploadCanvasImages(imgSVG, imgBase64);
    }
}

function addSvgToCanvas(svg, textData = null, removeActiveObject = false)
{
    if (!svg) {
        return;
    }
    fabric.loadSVGFromString(svg, function(objects, options) {
        objects.forEach(function(svg) {
            svg.set({
                top: canvas.height / 2,
                left: canvas.width / 2,
                originX: 'center',
                originY: 'center',
                transparentCorners: false
            });
            svg.scaleToWidth(60);
            svg.scaleToHeight(60);

            if (textData) {
                svg.text = textData.text;
                svg.textData = textData;
            }

            if (removeActiveObject) {
                let activeObject = canvas.getActiveObject();
                svg.left = activeObject.left;
                svg.top = activeObject.top;
                //svg.width = activeObject.width;
                //svg.height = activeObject.height;
                //svg.scaleToWidth(activeObject.width);
                //svg.scaleToHeight(activeObject.height);
                removeCanvasActiveObject();
            }

            canvas.add(svg).setActiveObject(svg).renderAll();
        });
    });
}

function renderDeleteButton()
{
    let deleteIcon = $("#delete-icon").val();
    let img = document.createElement('img');
    img.src = deleteIcon;

    fabric.Object.prototype.controls.deleteControl = new fabric.Control({
        x: 0.5,
        y: -0.5,
        offsetY: -16,
        offsetX: 16,
        cursorStyle: 'pointer',
        mouseUpHandler: deleteObject,
        render: renderIcon(img),
        cornerSize: 20
    });
}

function deleteObject(eventData, target) {
    var canvas = target.canvas;
    canvas.remove(target);
    canvas.requestRenderAll();
}

function renderIcon(icon) {
    return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
        var size = this.cornerSize;
        ctx.save();
        ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        ctx.drawImage(icon, -size/2, -size/2, size, size);
        ctx.restore();
    }
}

function centerCanvas()
{
    let containerHeight = $('#product-image-container').height();
    let containerWidth = $('#product-image-container').width();
    let canvasHeight = $("#product-image").height();
    let canvasWidth = $("#product-image").width();
    $(".canvas-container canvas").css({'top' : '0px'});
    $(".canvas-container canvas").css({'left' : '0px'});
    if (canvasWidth > canvasHeight) {
        let top = (containerHeight - canvasHeight ) / 2;
        $(".canvas-container canvas").css({'top' : top+'px'});
    } else if (canvasHeight > canvasWidth) {
        let left = (containerWidth - canvasWidth ) / 2;
        $(".canvas-container canvas").css({'left' : left+'px'});
    }
    canvas.renderAll();
}

function applyShapeToCanvas()
{
    let margin = 0;
    let shape = $("#shape").val();
    let container = $('#product-image-container');
    let background = getCanvasObjectById('backgroundColor');
    $(".canvas-container canvas").css({'top' : 0, 'left': 0});
    if (background) {
        switch (shape) {
            case 'CIRCLE':
                canvas.setWidth(container.width() - margin);
                canvas.setHeight(container.height() - margin);
                let radius = canvas.width / 2;
                let clipPath = new fabric.Circle({ radius: radius });
                canvas.clipPath = clipPath;
                scaleImage(background);
                break;

            case 'SQUARE':
                canvas.setWidth(container.width() - margin);
                canvas.setHeight(container.height() - margin);
                canvas.clipPath = null;
                scaleImage(background);
                break;

            case 'RECTANGLE':
                if ($('#coasterRectangle').length) {
                    canvas.setWidth(container.height());
                    let h = getProportionalSize(45, container.height(), 30);
                    canvas.setHeight(h);
                } else {
                    canvas.setWidth(container.width());
                    canvas.setHeight(Math.round(container.width() / 2));
                }
                canvas.clipPath = null;
                centerCanvas();
                break;

            default:
                canvas.clipPath = null;
                scaleImage(background);
                canvas.setWidth(background.width * background.scaleX);
                canvas.setHeight(background.height * background.scaleY);
                centerCanvas();
                break;
        }
        canvas.centerObject(background);
    }

    background = getCanvasObjectById('background');
    if (background) {
        $(".canvas-container canvas").css({'top': 0, 'left': 0});
        switch (shape) {
            case 'CIRCLE':
                canvas.setWidth(container.width() - margin);
                canvas.setHeight(container.height() - margin);
                let radius = canvas.width / 2;
                let clipPath = new fabric.Circle({radius: radius});
                canvas.clipPath = clipPath;
                scaleImage(background);
                break;

            case 'SQUARE':
                canvas.setWidth(container.width() - margin);
                canvas.setHeight(container.height() - margin);
                canvas.clipPath = null;
                scaleImage(background);
                break;

            case 'RECTANGLE':
                if ($('#coasterRectangle').length) {
                    canvas.setWidth(container.height());
                    let h = getProportionalSize(45, container.height(), 30);
                    canvas.setHeight(h);
                } else {
                    canvas.setWidth(container.width());
                    canvas.setHeight(Math.round(container.width() / 2));
                }
                canvas.clipPath = null;
                centerCanvas();
                scaleImage(background);
                break;

            default:
                canvas.clipPath = null;
                background = getCanvasObjectById('background');
                scaleImage(background);
                canvas.setWidth(background.width * background.scaleX);
                canvas.setHeight(background.height * background.scaleY);
                centerCanvas();
                break;
        }
        canvas.centerObject(background);
    }
    canvas.renderAll();
}

function scaleImage(image)
{
    let shape = $("#shape").val();
    let containerSize = $('#product-image-container').height();
    let scaleWidth = 0;
    let scaleHeight = 0;

    if (shape === 'ORIGINAL' || (shape === 'RECTANGLE' && !$('#coasterRectangle').length)) {
        if (image.height > image.width) {
            scaleHeight = containerSize;
        } else {
            scaleWidth = containerSize;
        }
    } else {
        if (image.height < image.width) {
            scaleHeight = containerSize;
        } else {
            scaleWidth = containerSize;
        }
    }

    if (scaleWidth) {
        image.scaleToWidth(scaleWidth);
    } else if (scaleHeight) {
        image.scaleToHeight(scaleHeight);
    }
}

function setShape(shape, shapeName)
{
    $(".shape-element").removeClass('selected');
    $('.shape-element[data-value="'+shape+'"]').addClass('selected');
    $("#shape").val(shape);
    $("#shape-name").val(shapeName);
}

function adjustTextureSize(objectId)
{
    let object = getCanvasObjectById(objectId);
    let objectTextureSize = Math.max(object.width, object.height);
    if (objectTextureSize > fabric.textureSize) {
        fabric.textureSize = objectTextureSize;
    }
}

function showOriginalShapeOption() {
    $('#shape-original').show();
    $('#shape-rectangle').hide();
}

function showRectangleShapeOption() {
    $('#shape-rectangle').show();
    $('#shape-original').hide();
}

function resetSizes() {
    $('#width, #widthPersonalized').val('');
    $('#height, #heightPersonalized').val('');
    let shape = $('.shape-element.selected');
    if (shape.length) {
        let width = shape.data('width');
        let height = shape.data('height');
        if (width && height && !isNaN(width) && !isNaN(height)) {
            $("#width").val(width);
            $("#height").val(height);
        }
    }
    let productType = parseInt($("#product-type").val());
    if (productType === 7) {
        $('#width, #height').val('1');
    }
}

function recalculateSizes() {
    $('#widthPersonalized, input[name="size"]:checked').trigger('change');
    $('input[name="composition"]:checked').click();
}

function updateRectangleBySizes(forcedWidth = null, forcedHeight = null) {
    let containerSize = $('#product-image-container').height();
    let width = forcedWidth || parseFloat($('#widthPersonalized').val());
    let height = forcedHeight || ($('#heightPersonalized').val());
    let newWidth = null;
    let newHeight = null;

    if (!width || !height) {
        return;
    }

    if (width > height) {
        newWidth = containerSize;
        newHeight = getProportionalSize(width, newWidth, height);
    } else if (height > width) {
        newHeight = containerSize;
        newWidth = getProportionalSize(height, newHeight, width);
    } else {
        newWidth = containerSize;
        newHeight = containerSize;
    }

    let object = getCanvasObjectById('backgroundColor');
    object.width = newWidth;
    object.height = newHeight;
    object = getCanvasObjectById('background');
    if (object) {
        object.width = newWidth;
        object.height = newHeight;
    }
    canvas.setWidth(newWidth);
    canvas.setHeight(newHeight);
    centerCanvas();
}

function getProportionalSize(originalSize, newSize, targetSize) {
    if (Number.EPSILON === undefined) {
        Number.EPSILON = Math.pow(2, -52);
    }

    let proportionalSize = (targetSize / originalSize) * newSize;
    proportionalSize = Math.round((proportionalSize + Number.EPSILON) * 100) / 100;

    return proportionalSize;
}

function removeCanvasActiveObject() {
    let object = canvas.getActiveObject();
    if (object) {
        canvas.remove(object);
    }
}

function checkIncorrectSizes() {
    $(".wrong-size-alert").hide();

    let customWidth = $('#widthPersonalized');
    let customHeight = $('#heightPersonalized');

    let errorSize = false;
    let width = Number(customWidth.val());
    let height = Number(customHeight.val());
    let optionsBlock = $('#options-measure');

    let widthMin = Number(customWidth.data('min'));
    let heightMin = Number(customHeight.data('min'));
    let widthMax = Number(customWidth.data('max'));
    let heightMax = Number(customHeight.data('max'));

    let wrongSizeAlertMin = optionsBlock.find('#wrong-size-alert-min');
    let wrongSizeAlertMax = optionsBlock.find('#wrong-size-alert-max');
    let wrongSizeAlertMaxWidth = optionsBlock.find("#wrong-size-alert-max-width");
    let wrongSizeAlertMaxHeight = optionsBlock.find("#wrong-size-alert-max-height");

    wrongSizeAlertMin.slideUp('fast');
    wrongSizeAlertMax.slideUp('fast');
    wrongSizeAlertMaxWidth.slideUp('fast');
    wrongSizeAlertMaxHeight.slideUp('fast');

    if (width && height) {
        if (width < widthMin || height < heightMin) {
            wrongSizeAlertMin.slideDown('fast');
            errorSize = true;
        } else if (widthMax && heightMax && width > widthMax && height > heightMax) {
            wrongSizeAlertMax.slideDown('fast');
            errorSize = true;
        } else if(widthMax && width > widthMax) {
            wrongSizeAlertMaxWidth.slideDown('fast');
            errorSize = true;
        } else if (heightMax && height > heightMax) {
            wrongSizeAlertMaxHeight.slideDown('fast');
            errorSize = true;
        }
    }

    return errorSize;
}

let updateAJAX;
function updatePrice(forceUpdateQuantitySelector = false) {
    if (typeof updateAJAX == 'object') {
        updateAJAX.abort();
    }

    if (forceUpdateQuantitySelector) $('input[name="quantity"][value="1"]').prop('checked', true);

    let material = 'wallpaper'; //$('input[name="material"]:checked').val();
    let productType = parseInt($("#product-type").val());
    if (productType === 3 && (!material || material === '')) {
        $("#material-empty-alert").slideDown();
        checkIncorrectSizes();
        return;
    } else {
        $("#material-empty-alert").slideUp();
    }

    let productId = $('#productId').val();
    let composition = $('#composition').val();
    let size = $("input[name='size']:checked");
    let width = $('#width').val()  ? $('#width').val() : 0;
    let height = $('#height').val() ? $('#height').val() : 0;
    let device = null;
    let pack = $("#pack").val();
    let isCatalogSize = 0;
    let clothingModel = $("#clothing-model").val();
    let tissue = $("#tissue").val();
    let mechanism = $("#mechanism").val();
    let drop = $("#fabric-drop").val();

    width = isNaN(width) ? 0 : width;
    height = isNaN(height) ? 0 : height;

    if (size.length) {
        width = size.data('width');
        height = size.data('height');
        device = size.data('device');
        isCatalogSize = 1;
    }

    let shapeSelected = $('.shape-element.selected');
    if (shapeSelected.data('width') && shapeSelected.data('height')) {
        isCatalogSize = 1;
    }

    let quantity = parseInt($('input[name="quantity"]:checked').val());

    if  (productType === 2 && size.val() === 'calculator') {
        quantity = size.data('quantity');
    }

    if ((width && height && quantity) || (composition && quantity) || (device && quantity) || (clothingModel && quantity)) {
        $('.btn-add-to-cart').attr('disabled', 'disabled');

        if (checkIncorrectSizes()) {
            return;
        }
        if (validatePacks()) {
            return;
        }

        let requestData = {
            productId: productId,
            composition: composition,
            width: width,
            height: height,
            device: device,
            quantity: quantity,
            options: {
                model: clothingModel,
                tissue: tissue,
                mechanism: mechanism,
                drop: drop
            },
            isCatalogSize: isCatalogSize
        }

        if (pack && pack !== '') {
            requestData.pack = pack;
        }

        updateAJAX = $.post(
            '/ajax/product/calculate-custom-price',
            requestData,
            function (data) {
                if (forceUpdateQuantitySelector) updateQuantitySelector(data.price);

                let total = data.price * quantity;

                if (total !== Math.floor(total)) {
                    total = total.toFixed(2);
                }

                total = getPriceFormat(total);
                $('.btn-item-price').text(total);
                $('.btn-add-to-cart').removeAttr('disabled');
                $('#preview-size span').html((width ? width : 0) + '&nbsp;x&nbsp;' + (height ? height : 0));

                if (data.warning && data.warning.length) {
                    popupInfoDialog(data.warning);
                }
            },
            'json'
        ).fail(function () {
            $('.btn-add-to-cart').removeAttr('disabled');
        });
    } else {
        $('.btn-item-price').text(0);
        $('#preview-size span').html((width ? width : 0) + '&nbsp;x&nbsp;' + (height ? height : 0));
    }
}

function createSummary() {
    $('.summary-text').html('');
    let width = $('#width').val() | 0;
    let height = $('#height').val() | 0;
    let shape = $('#shape-name').val();
    let effect = $('#effect-name').val();
    let composition = $('#composition-measures').val();
    let material = $('input[name="material"]:checked').data('translation');
    let numberOFCanvas = $('#composition-canvas').val();
    let pack = $("#pack").val();
    let model = $('input[name="clothing-model"]:checked').data('name');
    let clothingSize = $('input[name="clothing-size"]:checked').val();
    let materialColor = $('.material-color-selected').data('name');
    let tissue = $("#preview-tissue").text();
    let mechanism = $("#preview-mechanism").text();
    let fabricDrop = $("#preview-fabric-drop").text();
    let sizeText = '';
    composition = numberOFCanvas + " x (" + composition + ")";
    let imgBase64 = canvas.toDataURL({
        format: 'png'
    });

    let size = $("input[name='size']:checked").data('sizeName');

    if (model && model !== '' && clothingSize && clothingSize !== '') {
        sizeText = model + ' - ' + clothingSize;
    } else if (width && height) {
        sizeText = width+'x'+height;
    } else if (size !== '') {
        sizeText = size;
    }

    $('#summary-size').html(sizeText);
    $('#summary-image').attr('src', imgBase64);
    $('#summary-composition').html(composition);
    $('#summary-shape').html(shape);
    $("#summary-material").html(material);
    $("#summary-material-color").html(materialColor);
    $("#summary-tissue").html(tissue);
    $("#summary-mechanism").html(mechanism);
    $("#summary-fabric-drop").html(fabricDrop);

    let summaryPack = $("#summary-pack");
    if (summaryPack.length) {
        let packText = summaryPack.data('originalText').replace('%pack%', pack);
        summaryPack.html(packText);
    }

    if (effect === '-' || effect.length === 0) {
        $('.summary-effect-item').hide();
    } else {
        $('#summary-effect').html(effect);
        $('.summary-effect-item').show();
    }
}

function addToCart() {
    let productId = $('#productId').val();
    let designElements = $('#design-elements').val();
    let composition = $('#composition').val();
    let width = $('#width').val();
    let height = $('#height').val();
    let shape = $('#shape').val();
    let effect = $('#effect').val();
    let quantity = $('input[name="quantity"]:checked').val();
    let image = $('#image').val();
    let imageSVG = $('#imageSVG').val();
    let color = $('#color').val();
    let material = 'wallpaper'; //$('input[name="material"]:checked').val();
    let panelSize = $("#panelSize").val();
    let trim = $("#trim").val();
    let size = $("input[name='size']:checked");
    let pack = $("#pack").val();
    let model = $("#clothing-model").val();
    let materialColor = $("#material-color").val();
    let modelSize = $("#clothing-size").val();
    let tissue = $("#tissue").val();
    let mechanism = $("#mechanism").val();
    let chainPosition = $("#chain-position").val();
    let drop = $("#fabric-drop").val();
    let device = null;
    if (quantity < 1) {
        quantity = 1;
    }
    let roundedCorners = (shape !== 'CIRCLE') && ($("input[name='border-shape']:checked").val() === 'round');

    let convertUM = true;

    let shapeSelected = $('.shape-element.selected');
    if ((shapeSelected.data('width') && shapeSelected.data('height')) || composition) {
        convertUM = false;
    }

    if (size.length) {
        width = size.data('width');
        height = size.data('height');
        composition = size.data('composition');
        device = size.data('device');
        convertUM = false;
    }

    let complements = [];
    $('input[name="complement"]:checked').each(function() {
        let complement = $(this);
        complements.push(
            {
                'id': complement.data('id'),
                'locked': complement.data('locked'),
                'linkToParent': complement.data('link-to-parent'),
                'quantity': complement.data('quantity'),
                'options': {
                    'width': complement.data('width'),
                    'height': complement.data('height'),
                    'device': complement.data('device'),
                    'composition': complement.data('composition')
                }
            }
        );
    });

    let control = $("#control-data").val() !== '' ? JSON.parse($("#control-data").val()) : null;
    let charger = $("#charger-data").val() !== '' ? JSON.parse($("#charger-data").val()) : null;

    if (control && Object.keys(control).length) {
        complements.push(
            {
                'id': control.id,
                'locked': control.locked,
                'linkToParent': control.linkToParent,
                'quantity': control.quantity,
                'options': {
                    'width': control.width,
                    'height': control.height,
                    'device': control.device,
                    'composition': control.composition
                }
            }
        );
    }

    if (charger && Object.keys(charger).length) {
        complements.push(
            {
                'id': charger.id,
                'locked': charger.locked,
                'linkToParent': charger.linkToParent,
                'quantity': charger.quantity,
                'options': {
                    'width': charger.width,
                    'height': charger.height,
                    'device': charger.device,
                    'composition': charger.composition
                }
            }
        );
    }

    waitingDialog.show();

    let crossSellingProducts = [];
    $('.cross-selling-product:checked').each(function() {
        let product = $(this);
        let options = {
            'size': product.data('size-id'),
            'originalProduct': $('#productId').val(),
            'personalizedImage': product.data('image'),
            'color': product.data('color'),
            'width': product.data('width'),
            'height': product.data('height'),
            'device': product.data('device'),
            'composition': product.data('composition')
        };
        if (product.data('material-color')) {
            options['materialColor'] = product.data('material-color');
        }
        if (product.data('model')) {
            options['model'] = product.data('model');
        }
        if (product.data('pack')) {
            options['pack'] = product.data('pack');
        }
        crossSellingProducts.push(
            {
                'id': product.data('id'),
                'options': options,
                'locked': product.data('locked'),
                'linkToParent': product.data('link-to-parent')
            }
        );
    });

    let productType = parseInt($("#product-type").val());
    if (productType === 3 && (!material || material === '')) {
        let materialErrorText = $("#material-empty-alert").text();
        failureAddToCart({errorMessage: materialErrorText});
        return;
    }
    let referrer = null;
    if (document.referrer.indexOf(location.protocol + "//" + location.host) === 0) referrer = document.referrer;

    addToCartAjax(
        {
            productId: productId,
            quantity: quantity,
            options: {
                composition: composition,
                width: width,
                height: height,
                device: device,
                shape: shape,
                effect: effect,
                personalizedImage: image,
                personalizedSVG: imageSVG,
                color: color,
                pack: pack,
                panelSize: panelSize,
                trim: trim,
                model: model,
                materialColor: materialColor,
                modelSize: modelSize,
                tissue: tissue,
                mechanism: mechanism,
                chainPosition: chainPosition,
                drop: drop,
                designElements: designElements,
                roundedCorners: roundedCorners,
                referrer: referrer,
            },
            complements: complements,
            crossSellingProducts: crossSellingProducts,
            convertUM: convertUM,
            isLocked: true
        },
        function (data) {successAddToCart(data)},
        function (data) {failureAddToCart(data)}
    );
}

function successAddToCart(data) {
    resetSizes();
    $('.btn-item-price').text('0');
    $('.qty-display').val(1);
    recalculateSizes();
    updatePrice();

    if (data.cartItems) {
        $.each(data.cartItems, function (index, item) {
            if (item) {
                ecSendData(item.reference || '', item.name, item.price, item.quantity, item.colorApaCode, item.size, 'normal', 'add', null);
                trackEvent('PersonalizedProduct', 'AddToCart', $('h1').text());
                if (window.fbq) {
                    var payload = {
                        content_type: 'product',
                        content_name: item.name,
                        content_ids: [item.reference || ''],
                        contents: [
                            {
                                id: item.reference || '',
                                quantity: item.quantity,
                                price: item.price || 0
                            }
                        ],
                        value: item.price || 0,
                        currency: item.currency || ''
                    };
                    sendFacebookConversionsEvent('AddToCart', payload);
                }
                if (window.pintrk) {
                    pintrk('track', 'AddToCart', {
                        value: item.price,
                        order_quantity: item.quantity,
                        currency: item.currency
                    });
                }
            }
        });
    }
    waitingDialog.hide();
    sendFloodLightEvent();

    showShoppingCart();
}

function failureAddToCart(data) {
    trackEvent('PersonalizedProduct', 'AddToCart', 'error');
    let errorMessage = data.errorMessage;
    if (typeof errorMessage !== 'string') {
        errorMessage = 'Error';
    }
    waitingDialog.hide();
    popupInfoDialog(errorMessage);
}

function setCanvasBackgroundImageFullScreen(image, callback) {
    removeCanvasObject('background');
    fabric.Image.fromURL(image, function (img) {
        let scaleX = canvas.width / img.width;
        let scaleY = canvas.height / img.height;
        img.set({
            id: 'background',
            lockMovementY: true,
            lockMovementX: true,
            hasControls: false,
            hasBorders: false,
            selectable: false,
            hoverCursor: 'default',
            scaleX: scaleX,
            scaleY: scaleY
        });
        canvas.add(img);
        canvas.sendToBack(img);
        if (callback) {
            callback();
        }
    }.bind(this), {
        crossOrigin: 'anonymous'
    });
}

function setCanvasFrontImageFullScreen(image, callback) {
    removeCanvasObject('front');
    fabric.Image.fromURL(image, function (img) {
        let scaleX = canvas.width / img.width;
        let scaleY = canvas.height / img.height;
        img.set({
            id: 'front',
            lockMovementY: true,
            lockMovementX: true,
            hasControls: false,
            hasBorders: false,
            selectable: false,
            hoverCursor: 'default',
            scaleX: scaleX,
            scaleY: scaleY
        });
        canvas.add(img);
        canvas.bringToFront(img);
        if (callback) {
            callback();
        }
    }, null,{
        crossOrigin: 'Anonymous'
    });
}

function setCanvasBackgroundColorFullScreen(color, id) {
    removeCanvasObject(id);
    let width = $('#product-image-container').width();
    let height = $('#product-image-container').height();

    let options = {
        id: id,
        fill: color,
        lockMovementY: true,
        lockMovementX: true,
        hasControls: false,
        hasBorders: false,
        selectable: false,
        hoverCursor: 'default',
        width: width,
        height: height
    };
    let rect = new fabric.Rect(options);

    canvas.add(rect);
    canvas.sendToBack(rect);
    $('#product-image-start').hide();
    $('.inactive').removeClass('inactive');
    $('#background-color').val(color);
}

function changeCanvasViewByMode()
{
    let mode = $("#mode").val();
    if (mode === 'edit') {
        viewEditMode();
    } else if (mode === 'preview') {
        viewPreviewMode();
        canvas.discardActiveObject().renderAll();
    }
}

function viewEditMode(callback)
{
    let mockupLayer = $('.mockup-layer');
    let btnPreview =  $(".btn-preview-canvas");
    $(".btn-edit-canvas").addClass('hidden').prop('disabled', true);
    btnPreview.removeClass('hidden').prop('disabled', true);

    if (mockupLayer.length && !bothFrontImages) {
        mockupLayer.fadeOut();
        btnPreview.prop('disabled', false);
    } else {
        let background = $("#background").val();
        removeCanvasObject('front');
        setCanvasBackgroundImageFullScreen(background, function() {
            let backgroundColor = getCanvasObjectById('backgroundColor');
            let background = getCanvasObjectById('background');
            if (backgroundColor) {
                canvas.bringToFront(background);
            }
            btnPreview.prop('disabled', false);
            addOpacityAllCanvasObjects();

            if (callback) {
                callback();
            }
        });
    }
}

function viewPreviewMode(callback)
{
    let mockupLayer = $('.mockup-layer');
    let btnEdit = $(".btn-edit-canvas");
    $(".btn-preview-canvas").addClass('hidden').prop('disabled', true);
    btnEdit.removeClass('hidden').prop('disabled', true);

    if (mockupLayer.length && !bothFrontImages) {
        mockupLayer.fadeIn();
        btnEdit.prop('disabled', false);
    } else {
        removeCanvasObject('background');
        let front = $("#front").val();
        setCanvasFrontImageFullScreen(front, function () {
            btnEdit.prop('disabled', false);
            removeOpacityAllCanvasObjects();
            if (callback) {
                callback();
            }
        });
    }
}

function removeOpacityAllCanvasObjects()
{
    let objects = canvas.getObjects();
    objects.forEach(function (object) {
        if (object.selectable) {
            object.opacity = 1;
        }
    });
}

function addOpacityAllCanvasObjects()
{
    let objects = canvas.getObjects();
    objects.forEach(function (object) {
        if (object.selectable) {
            object.opacity = 0.5;
            canvas.bringToFront(object);
        }
    });
}

function uploadCanvasImages(imgSVG, imgBase64, callback)
{
    uploadImageSVG(
        imgSVG,
        imgBase64,
        {prefix: 'personalized'},
        function(data) {
            $('#image').val(data.file);
            $('#imageSVG').val(data.fileSVG);
            addToCart();
            if (callback) {
                callback();
            }
        }
    );
}

function changeVisualizationModeImages(background, front)
{
    let endPrefix = $("#visualization-images-end-prefix").val();

    if (endPrefix) {
        let backgroundParts = background.split('.');
        background = backgroundParts[0] + endPrefix + '.' + backgroundParts[1];
        let frontParts = front.split('.');
        front = frontParts[0] + endPrefix + '.' + frontParts[1];
    }

    $("#front").val(front);
    $("#background").val(background);
    changeCanvasViewByMode();
}

function applyBorderShapeToCanvas()
{
    let shape = $("#shape").val();
    let borderShape = $("input[name='border-shape']:checked").val();
    if (shape === 'SQUARE' || shape === 'RECTANGLE') {
        switch (borderShape) {
            case 'straight':
                canvas.clipPath = null;
                break;
            case 'round':
                let clipPath = new fabric.Rect({
                    width: canvas.width,
                    height: canvas.height,
                    rx: 20,
                    ry: 20
                });
                canvas.clipPath = clipPath;
                break;
        }
        canvas.renderAll();
    }
}

function setObjectEditable(object)
{
    object.lockMovementY = false;
    object.lockMovementX = false;
    object.hasControls = true;
    object.hasBorders = true;
    object.selectable = true;
    object.borderColor = '#000';
    object.cornerColor = '#000';
    object.transparentCorners = false;
}

function validatePacks()
{
    let packInput = $("#pack");
    let error = false;
    if (packInput.length) {
        let alert = $("#alert-min-pack");
        alert.hide();
        let pack = parseInt(packInput.val());
        let minPack = parseInt($("#min-pack").val());
        if (!pack || pack < minPack) {
            error = true;
            alert.slideDown();
        }
    }

    return error;
}

let ajaxUpdatePricesByPack = null;
function updateSizesPriceByPack()
{
    if (ajaxUpdatePricesByPack) {
        ajaxUpdatePricesByPack.abort();
    }

    ajaxUpdatePricesByPack = $.post(
        '/ajax/product/update-pack-prices',
        {
            productId: $("#productId").val(),
            pack: $("#pack").val(),
        },
        function (data) {
            data.prices.forEach(function(size) {
                let input = $('input[name="size"][value="'+size.id+'"]');
                input.closest('.product-option-radio').find('.size-price').html(size.formattedPrice);
            });
        }
    );
}

function setCanvasBackgroundImageProportionalScale(image, callback) {
    let containerSize = canvas.width;
    fabric.Image.fromURL(image, function (img) {
        let scaleWidth = containerSize;
        let scaleHeight = 0;
        if (img.height > img.width) {
            containerSize = canvas.height;
            scaleWidth = 0;
            scaleHeight = containerSize;
        }

        img.set({
            id: 'background',
            lockMovementY: false,
            lockMovementX: false,
            hasControls: true,
            hasBorders: true,
            selectable: true,
            borderColor: '#000',
            cornerColor: '#000',
            transparentCorners: false,
            hoverCursor: 'default'
        });

        if (scaleWidth) {
            img.scaleToWidth(scaleWidth);
        } else if (scaleHeight) {
            img.scaleToHeight(scaleHeight);
        }

        canvas.add(img);
        img.center();
        $('#select-filter').show();
        $('.inactive').removeClass('inactive');
        $('#backgroundImage').val('');
        if (callback) {
            callback();
        }
    }.bind(this), {
        crossOrigin: 'anonymous'
    });
}

function updatePreviewInformation(element, content)
{
    if (!element && !content) {
        let previewElement = $('.update-preview-information:checked, .update-preview-information:selected');
        element = previewElement.data('previewElement');
        content = previewElement.data('previewContent');
    }

    $(element).html(content);
}

function selectDefaultFont() {
    let defaultFont = getDefaultFont();
    $('#font').val(defaultFont.data('name'));
    $('#font-file').val(defaultFont.data('file'));
    $('#font-rtl').val(defaultFont.data('rtl'));
}

function getPercentValue(percent, total)
{
    return (percent * total) / 100;
}

function updateCanvasSizes(width, height)
{
    canvas.setWidth(width);
    canvas.setHeight(height);
}

function marginTopCanvasByPercent(margin)
{
    let canvasElement = $(".canvas-container canvas");
    canvasElement.css({'top' : margin+'px'});
    canvas.renderAll();
}

function centerCanvasHorizontally()
{
    let containerWidth = $('#product-image-container').width();
    let canvasWidth = $("#product-image").width();
    let canvasElement = $(".canvas-container canvas");
    canvasElement.css({'left' : '0px'});
    let left = (containerWidth - canvasWidth ) / 2;
    canvasElement.css({'left' : left+'px'});
    canvas.renderAll();
}

function changeElementsVisualization(elementToHide, elementToShow)
{
    if (elementToHide) {
        $(elementToHide).addClass('hidden');
    }

    if (elementToShow) {
        $(elementToShow).removeClass('hidden');
    }
}

function changeTShirtImage()
{
    let productTypeName = $("#product-type-name").val();
    let model = $('#clothing-model').val();
    let materialColor = $("#material-color").data('code');
    let mockupLayer = productTypeName+'-'+model+'-'+materialColor;
    changeMockupLayerBack(mockupLayer);
}

function changeMockupLayerBack(id)
{
    $('.mockup-layer-back').attr('id', id);
}

function selectMaterialColor(element)
{
    $('.material-color-select').removeClass('material-color-selected');
    element.addClass('material-color-selected');
    $("#material-color").val(element.data('id')).data('code', element.data('code'));
}

function updateClothingSizes(callback)
{
    $.post(
        '/ajax/personalized-services/render-clothing-sizes',
        {
            productId: $("#productId").val(),
            modelId: $("#clothing-model").val()
        },
        function(data){
            $("#div-clothing-sizes").html(data.view);
            callback();
        }
    );
}

function updatePreviewInformationTShirt()
{
    let model = $('input[name="clothing-model"]:checked').data('name');
    let size = $('input[name="clothing-size"]:checked').val();
    $("#preview-size").html(model + ' - ' + size);
}

function showInfoDialog(type, productId, model)
{
    $.get(
        '/ajax/popup/info-dialog',
        {
            type: type,
            productId: productId,
            model: model
        },
        function (data) {
            popupInfoDialog(data.content);
        },
        'json'
    );
}

function recalculateProportionalCanvasSize(width, height, maxWidth, maxHeight)
{
    let canvasWidth = maxWidth;
    let canvasHeight = maxWidth;

    if (width && height) {
        if (width > height) {
            canvasHeight = (maxWidth * height) / width;
            canvasWidth = maxWidth;
        } else if (height > width) {
            canvasWidth = (maxWidth * width) / height;
            canvasHeight = maxHeight;
        }
    }

    updateCanvasSizes(canvasWidth, canvasHeight);
    centerCanvasHorizontally();
}

function rescaleImage(img)
{
    let containerSize = canvas.width;
    let scaleWidth = containerSize;
    let scaleHeight = 0;
    if (img.height > img.width) {
        containerSize = canvas.height;
        scaleWidth = 0;
        scaleHeight = containerSize;
    }

    if (scaleWidth) {
        img.scaleToWidth(scaleWidth);
    } else if (scaleHeight) {
        img.scaleToHeight(scaleHeight);
    }
    img.center();
    canvas.renderAll();
}

function scrollToPosition(scrollPosition)
{
    $('html, body').animate({ scrollTop: scrollPosition}, 1000);
}

function displaySelectedCatalogProduct()
{
    let colorSelected = $('.color-selected').data('hex');
    setCanvasBackgroundColorFullScreen(colorSelected, 'backgroundColor');
}

function menuComplete(object)
{
    let icon = object.find('.ps-icon');
    icon.removeClass('ps-green-icon').addClass('ps-green-icon')
    object.addClass('completed');
}

function menuIncomplete(object)
{
    let icon = object.find('.ps-icon');
    icon.removeClass('ps-green-icon');
    object.removeClass('completed');
}

function updateMaterialColors(materialColorsToShow)
{
    if (!materialColorsToShow) return;

    $('.material-color').hide();
    let maxElementsPerRow = 2;
    let columns = materialColorsToShow.length > maxElementsPerRow ? '6' : 12 / materialColorsToShow.length;
    materialColorsToShow.forEach(function(materialColorToShow, index) {
        let numberOfElement = index + 1;
        let isEven = numberOfElement%2 === 0;
        let element = $(`.material-color[data-material-color-id="${materialColorToShow}"]`);
        element.removeClass('col-xs-12 col-xs-6');
        element.addClass(`col-xs-${columns}`);
        element.removeClass('text-center text-left');
        let textAlign = isEven ? 'text-left' : 'text-center';
        element.addClass(textAlign);
        element.show();
    });
}

function updateQuantitySelector(price)
{
    $.post(
        '/ajax/personalized-services/get-quantity-selector',
        {
            productId: $("#productId").val(),
            price: price
        },
        function(data){
            if (data.quantitySelector && data.quantitySelector.length) {
                $('.add-to-cart-quantity-selector').html(data.quantitySelector);
                if (getDeviceType() !== 'desktop') $("#dropdownQuantitySelector").closest('.quantity-selector').removeClass('dropdown').addClass('dropup');
            }
        }
    );
}

function resetCalculator()
{
    let size = $("input[name='size'][value='calculator']");

    size.data('width', '');
    size.data('height', '');
    size.data('quantity', '1');
    size.data('composition', '');
    size.data('device', '');

    let glueComplement = $('#complement-486');
    glueComplement.data('quantity', '1');
    glueComplement.prop('checked', false).trigger('change');

    $('#calculatorWidthPersonalized').val('');
    $('#calculatorHeightPersonalized').val('');
}

function collapseWallpaperCalculator()
{
    $('.wallpaper-calculator-toggle').attr('aria-expanded', 'false');
    $('.wallpaper-calculator-box').removeClass('expanded');
    $('.options-calculator').slideUp();
    $('#calculator-option').slideDown();
    $('#calculator-result').slideUp();
    resetCalculator();
}

(function () {
    'use strict';

    function togglePanel(button) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        var isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
            // Cerrar
            panel.style.setProperty('--tv-panel-height', panel.scrollHeight + 'px');
            // forzar reflow para que la transición arranque
            void panel.offsetHeight;
            panel.style.setProperty('--tv-panel-height', '0px');
            button.setAttribute('aria-expanded', 'false');
            // ocultar al terminar la transición
            panel.addEventListener('transitionend', function handler() {
                panel.hidden = true;
                panel.removeEventListener('transitionend', handler);
            });
        } else {
            // Abrir
            panel.hidden = false;
            panel.style.setProperty('--tv-panel-height', panel.scrollHeight + 'px');
            button.setAttribute('aria-expanded', 'true');
        }
    }

    document.addEventListener('click', function (e) {
        var button = e.target.closest('.tv-faqs__header');
        if (!button) return;
        togglePanel(button);
    });
})();